namespace GeniuzPOS.PosShift {
    export interface PsQueueRow {
        Id?: number;
        ShopId?: string;
        TodayDate?: string;
        LastQueueNo?: number;
    }

    export namespace PsQueueRow {
        export const idProperty = 'Id';
        export const nameProperty = 'Id';
        export const localTextPrefix = 'PosShift.PsQueue';
        export const deletePermission = 'Administration:General';
        export const insertPermission = 'Administration:General';
        export const readPermission = 'Administration:General';
        export const updatePermission = 'Administration:General';

        export declare const enum Fields {
            Id = "Id",
            ShopId = "ShopId",
            TodayDate = "TodayDate",
            LastQueueNo = "LastQueueNo"
        }
    }
}
